import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isProduction: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    isProduction: process.env.NODE_ENV === 'production',
  };

  public static getDerivedStateFromError = () => ({ hasError: true });

  public componentDidCatch = (error: Error, errorInfo: ErrorInfo) =>
    console.error('Error boundary - Review PDP', error, errorInfo);

  public render() {
    const { hasError, isProduction } = this.state;
    const { children } = this.props;

    return !hasError || !isProduction ? children : null;
  }
}

export default ErrorBoundary;
export { ErrorBoundary };
